import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { postRoomFromGroup } from "../services/AnimalSplitCore";
import { initRoom as initTexasRoom } from "../services/TexasService";
import { useTranslation } from "react-i18next";
import "./ModalTheme.css";

// Keep aligned with GameRoom.jsx
const gameCategories = [
  {
    id: 2,
    icon: "♠️",
    i18nKey: "texas",
    gameType: "texas-holdem",
    comingSoon: false,
    relatedCategories: ["meal", "snacks", "drinks"],
  },
];

export default function GameCenterModal(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { modalId, groupId, transactions, setIsLoading } = props;
  const [error, setError] = useState(null);

  const availableGames = gameCategories.filter((g) => !g.comingSoon);

  const handleCreateRoom = async (gameType) => {
    setError(null);

    setIsLoading?.(true);
    try {
      const response = await postRoomFromGroup(groupId, gameType);
      const roomId = response.id;

      if (gameType === "texas-holdem") {
        await initTexasRoom(roomId);
        history.push(`${process.env.PUBLIC_URL}/games/texas/${roomId}`);
      } else {
        history.push(`${process.env.PUBLIC_URL}/games/room/${roomId}`);
      }
    } catch (err) {
      console.error("Error creating room:", err);
      setError(t("games.group_card.create_room_error"));
    } finally {
      setIsLoading?.(false);
    }
  };

  return (
    <div className="modal fade" id={modalId} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div className="modal-content as-modal as-theme">
          <div className="modal-header">
            <div className="as-modal-header-row">
              <div className="as-modal-title-row">
                <span className="as-modal-icon-badge" aria-hidden="true">
                  🎮
                </span>
                <h5 className="modal-title">Game Center</h5>
              </div>
              <div className="as-modal-actions">
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>
            </div>
          </div>

          <div className="modal-body">
            <p className="text-muted small mb-2">{t("games.group_card.subtitle")}</p>

            {error ? (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                {error}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setError(null)}
                  aria-label={t("general.close")}
                ></button>
              </div>
            ) : null}

            <div className="d-grid gap-2">
              {availableGames.map((game) => (
                <button
                  key={game.id}
                  className="btn btn-outline-primary btn-sm d-flex align-items-center justify-content-between"
                  onClick={() => handleCreateRoom(game.gameType)}
                >
                  <span>
                    <span className="me-2">{game.icon}</span>
                    {t(`games.categories.items.${game.i18nKey}.title`)}
                  </span>
                  <i className="bi bi-arrow-right"></i>
                </button>
              ))}
            </div>

            {/* keep signature parity; transactions unused for now */}
            {transactions ? null : null}
          </div>

          <div className="modal-footer as-modal-footer">
            <button type="button" className="btn as-btn-soft" data-bs-dismiss="modal">
              {t("general.close")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

